import { render, staticRenderFns } from "./AddMasterRate.vue?vue&type=template&id=56ae2f92"
import script from "./AddMasterRate.vue?vue&type=script&lang=js"
export * from "./AddMasterRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports